export default __webpack_public_path__ + "static/media/tray.fbe89b56.jpg";